// Campaign cards are real links, but on desktop a click opens the campaign in a
// modal instead of navigating. Shared by CampaignCard (listing) and
// CampaignMiniCard (candidate/party profile tabs) so the two can't disagree.
//
// Modified clicks and non-primary buttons are left alone, so cmd/ctrl-click and
// middle-click still open the detail page in a new tab. The breakpoint is read
// at click time rather than during render, which keeps SSR and client markup
// identical.
const DESKTOP_QUERY = '(min-width: 1024px)';

export function opensCampaignModal(event: MouseEvent): boolean {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return false;
  }
  if (event.button !== 0) return false;

  return (
    typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches
  );
}
